// extracted by mini-css-extract-plugin
export default {"dropdown-right":"styles_dropdown-right__R31+9"};